import React from 'react';
import { Create, SimpleForm } from 'react-admin';
import { FormPageTitle, FormToolbar } from '@/components/shell';
import { LicenseFields } from './LicenseFields';

const BACK_TO = '/system?tab=licenses';

interface LicenseFormValues {
  licenseName: string;
  serverIds?: string[];
}

const transform = (data: LicenseFormValues) => ({
  licenseName: data.licenseName,
  serverId: data.serverIds || [],
});

export const LicenseCreate = () => (
  <Create transform={transform} actions={<FormPageTitle mode="create" />}>
    <SimpleForm toolbar={<FormToolbar backTo={BACK_TO} />}>
      <LicenseFields />
    </SimpleForm>
  </Create>
);
